/**
 * C - Main Product: Swiper Gallery + Thumbs initialization
 * Requires Swiper to be globally loaded (theme.liquid)
 */
(function () {
  function initCMainProductSwipers() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.c-main-product').forEach(function (section) {
      var sectionId = section.id.replace('c-main-product-', '');
      var thumbsEl = section.querySelector('#product-thumbs-' + sectionId);
      var mainEl = section.querySelector('#product-swiper-' + sectionId);

      if (!mainEl) return;

      // Already initialized
      if (mainEl.swiper) return;

      var thumbsSwiper = null;

      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          spaceBetween: 8,
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            0: {
              slidesPerView: 5,
              spaceBetween: 6
            },
            768: {
              slidesPerView: 6,
              spaceBetween: 8
            },
            1024: {
              slidesPerView: 7,
              spaceBetween: 10
            }
          }
        });
      }

      new Swiper(mainEl, {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
      });
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCMainProductSwipers);
  } else {
    initCMainProductSwipers();
  }

  // Re-init on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.c-main-product')) {
      setTimeout(initCMainProductSwipers, 100);
    }
  });
})();
